import React from "react";
import { AlertTriangle } from "lucide-react";
import ModalShell from "../ModalShell";
import { deptName } from "../../utils/names";
import ReusableDropdown from "../../../../components/ReusableDropdown";

const DepartmentFormModal = ({ styles, t, language, busy, form, setForm, onClose, onSave, companies = [], theme }) => {
  const isEdit = form.mode === "edit";
  // "All companies" view: a new department still has to belong to one company.
  const needsCompany = !isEdit && form.workingCompany !== undefined && companies.length > 0;
  const canSave = !busy && form.name.trim() && (!needsCompany || form.workingCompany);
  const renaming = isEdit && form.name.trim() !== form.dept.name;

  return (
    <ModalShell
      styles={styles}
      t={t}
      busy={busy}
      onClose={onClose}
      title={isEdit ? t.editTitle : t.createTitle}
      subtitle={isEdit ? deptName(form.dept, language) : null}
      footer={
        <>
          <button type="button" style={styles.btnSecondary(busy)} disabled={busy} onClick={onClose}>{t.cancel}</button>
          <button type="button" className="dept-btn-primary" style={styles.btnPrimary(!canSave)} disabled={!canSave} onClick={onSave}>
            {t.save}
          </button>
        </>
      }
    >
      {needsCompany && (
        <div style={styles.field}>
          <label style={styles.label}>{t.company} *</label>
          <ReusableDropdown
            items={companies}
            value={form.workingCompany}
            onChange={(value) => setForm({ ...form, workingCompany: value })}
            placeholder={t.companyRequired}
            getItemKey={(c) => c}
            getItemLabel={(c) => c}
            searchable={companies.length > 7}
            theme={theme}
            language={language}
          />
        </div>
      )}
      <div style={styles.field}>
        <label style={styles.label} htmlFor="dept-name-en">{t.nameEn} *</label>
        <input
          id="dept-name-en"
          className="dept-input"
          style={styles.fieldInput}
          dir="ltr"
          value={form.name}
          placeholder={t.namePlaceholder}
          onChange={(e) => setForm({ ...form, name: e.target.value })}
          autoFocus={!needsCompany}
        />
      </div>
      <div style={{ ...styles.field, marginBottom: renaming ? "16px" : 0 }}>
        <label style={styles.label} htmlFor="dept-description">{t.descriptionLabel}</label>
        <input
          id="dept-description"
          className="dept-input"
          style={styles.fieldInput}
          dir="auto"
          value={form.description}
          placeholder={t.descriptionPlaceholder}
          onChange={(e) => setForm({ ...form, description: e.target.value })}
        />
      </div>
      {renaming && (
        <div style={styles.notice("warning")}>
          <AlertTriangle size={16} style={{ flexShrink: 0, marginTop: "3px" }} />
          <span>{t.renameCascadeNote}</span>
        </div>
      )}
    </ModalShell>
  );
};

export default DepartmentFormModal;
